import React from 'react';

import {useTranslation} from 'react-i18next';

import {DropdownMenu} from 'components/ui-kit/DropdownMenu';

export const LineControlComponent = ({
    allowToCopyData,
    allowToDuplicateDown,
    allowToDelete,
    onCopyData,
    onDuplicateDown,
    onRemoveField,
    fieldsLength,
}: {
    allowToCopyData: boolean;
    allowToDuplicateDown: boolean;
    allowToDelete: boolean;
    onCopyData: () => void;
    onDuplicateDown: () => void;
    onRemoveField: () => void;
    fieldsLength: number;
}) => {
    const {t: translation} = useTranslation();
    const GEN_INFO = 'pages.documents.invoices.create.invoiceLines.control';
    const t = (key: string, vars?: Record<string, any>) =>
        translation(`${GEN_INFO}.${key}`, vars ?? {});

    const bullets = `•••`;
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <DropdownMenu noIcon={true} label={bullets}>
                <DropdownMenu.List style={{zIndex: 1200, position: 'relative'}}>
                    {allowToCopyData && (
                        <DropdownMenu.Item onSelect={() => onCopyData()}>
                            {t('spread')}
                        </DropdownMenu.Item>
                    )}
                    {allowToDuplicateDown && (
                        <DropdownMenu.Item onSelect={() => onDuplicateDown()}>
                            {t('copy')}
                        </DropdownMenu.Item>
                    )}
                    {allowToDelete && (
                        <DropdownMenu.Item onSelect={() => onRemoveField()}>
                            {fieldsLength > 1 ? t('delete') : t('clear')}
                        </DropdownMenu.Item>
                    )}
                </DropdownMenu.List>
            </DropdownMenu>
        </div>
    );
};
